import ImageUrl from "components/app/image-url/ImageUrl";
import SearchBar from "components/app/search-bar/SearchBar";
import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import { Globe, Grid2x2, WalletCards } from "lucide-react";
import { useEffect, useState } from "react";

import { ShimmerDepartmentRender, ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { Link, useLocation } from "react-router-dom";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import DailogDetailTools from "./dialogStaff/DailogDetailTools";
import { appStoreLogo, playStoreLogo } from "assets";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";

export default function Tools() {
  const [types, setTypes] = useState<any>();
  const [tools, setTools] = useState<any>();
  const { token } = useAppSelector((state) => state.auth);

  const [toolsloading, setToolsloading] = useState<boolean>();
  const [toolsloadingSearch, setToolsloadingSearch] = useState<boolean>();

  const [selectToolsTypes, setSelectToolsTypes] = useState<any>("");

  const [searchTextInput, setSearchTextInput] = useState<string>("");

  const fetchTools = async () => {
    setToolsloading(true);
    try {
      const url = `${RouteApi.getTools}token=${token}`;
      const data = {
        shop_id: "",
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setTypes(response["types"]);
        setToolsloading(false);
      }
    } catch (error) {
      setToolsloading(false);
      AppLog.show({
        message: `[fetchTools]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const fetchToolsSearch = async () => {
    setToolsloadingSearch(true);
    try {
      const url = `${RouteApi.getToolSearch}token=${token}`;
      const data = {
        type: selectToolsTypes,
        search_text: searchTextInput,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setTools(response["tools"]);
        setToolsloadingSearch(false);
      }
    } catch (error) {
      setToolsloadingSearch(false);
      AppLog.show({
        message: `[fetchToolsSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  useEffect(() => {
    fetchTools();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    fetchToolsSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput, selectToolsTypes]);
  const handleClickCategory = ({ types }: { types: string }) => {
    if (selectToolsTypes === types) return;
    setSelectToolsTypes(types);
  };
  const [view, setView] = useState("card");

  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("tools-display-layout", selectedView);
  };

  useEffect(() => {
    const savedView = localStorage.getItem("tools-display-layout");
    if (savedView) {
      setView(savedView);
    }
  }, []);

  const [isDailogDetailTools, setIsDailogDetailTools] = useState<boolean>(false);
  const [isDetailTools, setIsDetailTools] = useState<any>(null);
  const location = useLocation();
  // -------------------------

  return (
    <>
      {["/tools-account"].includes(location.pathname) ? (
        <>
          <div
            onWheel={(e) => {
              e.stopPropagation();
            }}
          >
            <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
              <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
                <div className="lg:w-auto md:w-auto w-full">
                  <h1 className="font-semibold lg:text-lg md:text-md text-sm">Tools</h1>
                  <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Cost-Effective Tools to Empower Small Businesses</p>
                </div>
                <nav className="lg:w-auto md:w-auto w-full border-gray-200 pt-5 flex items-center justify-end lg:flex lg:items-center lg:justify-between md:flex md:items-center md:justify-between ">
                  {/* Search & View Switch */}
                  <div className="flex items-center gap-2 w-full ">
                    <div className="flex-1  lg:me-2 me-2">
                      <div className="relative">
                        <SearchBar
                          onValueChange={(value) => {
                            setSearchTextInput(value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="relative">
                    {view === "card" ? (
                      <button
                        onClick={() => changeView("table")}
                        className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-9 h-9 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <Grid2x2 className="font-semibold size-5" />
                      </button>
                    ) : (
                      <button
                        onClick={() => changeView("card")}
                        className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <WalletCards className="text-xl" />
                      </button>
                    )}
                  </div>
                </nav>
              </div>
              <div className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar `}>
                {/* Hover Overflow Scroll Container */}
                <div className="relative w-full ">
                  <div className="flex space-x-2 w-full">
                    {/* Add Category */}

                    {/* "All" Category */}
                    <div
                      onClick={() => {
                        if (selectToolsTypes === "All") {
                        }
                        handleClickCategory({
                          types: "",
                        });
                      }}
                      className={` lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
                        selectToolsTypes === "" ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200" : "dark:hover:bg-slate-900"
                      } `}
                    >
                      <span>All</span>
                    </div>
                    {/* Product Categories */}
                    <div className="space-x-2 flex">
                      {toolsloading ? (
                        <>
                          <ShimmerDepartmentRender />
                        </>
                      ) : (
                        <>
                          {types?.map((sale: any, index: any) => (
                            <button
                              key={index}
                              onClick={() => {
                                handleClickCategory({
                                  types: sale ?? "", // Ensure it's a string or fallback to ""
                                });
                              }}
                              className={` outline-none focus:border-none whitespace-nowrap border lg:px-4 md:px-4 px-2 py-0 rounded-lg xl:text-md text-sm font-semibold
                            ${selectToolsTypes === (sale ? sale.toString() : "") ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200" : "dark:hover:bg-slate-900"}`}
                            >
                              {sale}
                            </button>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {view === "card" ? <></> : <>{toolsloadingSearch && <SkeletonMusicLibrariesTable />}</>}
            <div className="pb-3 h-full mt-5">
              {view === "card" ? (
                <>
                  {toolsloadingSearch ? (
                    <>
                      <ShimmerStaffRender />
                    </>
                  ) : (
                    <>
                      <div className={`grid md:grid-cols-3  ${window.innerWidth <= 1500 ? " lg:grid-cols-6" : "lg:grid-cols-8"}  gap-y-3 gap-x-2 mb-10 `}>
                        {tools?.map((item: any, index: number) => {
                          return (
                            <div
                              onClick={() => {
                                setIsDailogDetailTools(true);
                                setIsDetailTools(item);
                              }}
                              key={index}
                              className="relative z-1 w-full max-w-sm border rounded-lg cursor-pointer"
                            >
                              <div className="w-full relative overflow-hidden">
                                <ImageUrl className="rounded-t-md cursor-pointer object-cover h-[220px] w-full" src={item?.image_url} alt="" />
                              </div>
                              <div className="p-4">
                                <h5 className="text-md font-semibold line-clamp-1 overflow-hidden ">{item?.title}</h5>
                                <span className="text-sm text-muted-foreground line-clamp-1 overflow-hidden">{item?.type}</span>
                                <span className="text-sm line-clamp-3 overflow-hidden h-[65px]">{item?.sub_title}</span>
                                <span className="text-md font-semibold ">Learn more...</span>

                                <div onClick={(e) => e.stopPropagation()} className="flex items-center gap-2 h-[20px] mt-4">
                                  {item.ios_url && (
                                    <Link to={item?.ios_url} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
                                      <img src={appStoreLogo} className={`${window.innerWidth > 1500 ? "w-[40px] h-[40px]" : "w-[20px] h-[20px]"}`} alt="logo" />
                                    </Link>
                                  )}
                                  {item.android_url && (
                                    <Link to={item?.android_url} target="_blank" rel="noopener noreferrer">
                                      <img src={playStoreLogo} className={`${window.innerWidth > 1500 ? "w-[30px] h-[30px]" : "w-[20px] h-[20px]"}`} alt="logo" />
                                    </Link>
                                  )}
                                  {item.web_url && (
                                    <Link to={item?.web_url} target="_blank" rel="noopener noreferrer">
                                      <Globe className={` ${window.innerWidth > 1500 ? "w-[30px] h-[30px]" : "w-[20px] h-[20px]"} text-blue-500`} />
                                    </Link>
                                  )}
                                  {item.window_url && (
                                    <Link to={item?.window_url} target="_blank" rel="noopener noreferrer">
                                      <i className={`fa-brands fa-windows ${window.innerWidth > 1500 ? "text-[30px]" : "text-[20px]"} text-blue-500`} />
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
                    <thead className="sticky top-0 left-0 bg-gray-200 dark:bg-[#2c3a52] w-full">
                      <tr className="border-none">
                        <th className="py-2  px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                        <th className="py-2 px-4 text-start ">Title</th>
                        <th className="py-2 px-4 text-start ">Types</th>
                        <th className="py-2 px-4 text-start">Sub title</th>
                        <th className="py-2 px-4 text-start">Learn more</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tools?.map((item: any, index: number) => (
                        <tr
                          onClick={() => {
                            setIsDailogDetailTools(true);
                            setIsDetailTools(item);
                          }}
                          key={index}
                          className={`text-center cursor-pointer ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}
                        >
                          <td className="relative w-[100px] h-[100px]">
                            <ImageUrl src={item.image_url} className="w-[100px] h-[100px] z-1 mx-auto relative" alt="" />
                          </td>
                          <td className="py-2 px-4 text-md  text-start ">
                            <p className="text-md ">{item?.title}</p>
                          </td>
                          <td className="py-2 px-4 text-md  text-start ">
                            <p className="text-md ">{item?.type}</p>
                          </td>
                          <td className="py-1 px-4 text-md text-start  line-clamp-3 ">
                            <span
                              className="  overflow-hidden"
                              dangerouslySetInnerHTML={{
                                __html: item?.sub_title.replace(/\n/g, "<br />"),
                              }}
                            ></span>
                          </td>
                          <td className="py-2 px-4 text-md   ">
                            <div className="flex items-center gap-2 h-[20px]">
                              {item.ios_url && (
                                <Link to={item?.ios_url} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
                                  <img src={appStoreLogo} className={`${window.innerWidth > 1500 ? "w-[40px] h-[40px]" : "w-[20px] h-[20px]"}`} alt="logo" />
                                </Link>
                              )}
                              {item.android_url && (
                                <Link to={item?.android_url} target="_blank" rel="noopener noreferrer">
                                  <img src={playStoreLogo} className={`${window.innerWidth > 1500 ? "w-[30px] h-[30px]" : "w-[20px] h-[20px]"}`} alt="logo" />
                                </Link>
                              )}
                              {item.web_url && (
                                <Link to={item?.web_url} target="_blank" rel="noopener noreferrer">
                                  <Globe className={` ${window.innerWidth > 1500 ? "w-[30px] h-[30px]" : "w-[20px] h-[20px]"} text-blue-500`} />
                                </Link>
                              )}
                              {item.window_url && (
                                <Link to={item?.window_url} target="_blank" rel="noopener noreferrer">
                                  <i className={`fa-brands fa-windows ${window.innerWidth > 1500 ? "text-[30px]" : "text-[20px]"} text-blue-500`} />
                                </Link>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <BusinessSuiteContentLayout>
          <div
            onWheel={(e) => {
              e.stopPropagation();
            }}
          >
            <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
              <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
                <div className="lg:w-auto md:w-auto w-full">
                  <h1 className="font-semibold lg:text-lg md:text-md text-sm">Tools</h1>
                  <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Cost-Effective Tools to Empower Small Businesses</p>
                </div>
                <nav className="lg:w-auto md:w-auto w-full border-gray-200 pt-5 flex items-center justify-end lg:flex lg:items-center lg:justify-between md:flex md:items-center md:justify-between ">
                  {/* Search & View Switch */}
                  <div className="flex items-center gap-2 w-full ">
                    <div className="flex-1  lg:me-2 me-2">
                      <div className="relative">
                        <SearchBar
                          onValueChange={(value) => {
                            setSearchTextInput(value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <HoverCardDetail
                    title=""
                    description={
                      <>
                        <p className="mb-2 font-medium text-sm dark:text-white">Switch between different display modes to view your tools or items.</p>
                        <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                          <li>
                            <strong>Card View:</strong> Displays items as individual cards with detailed info and visuals.
                          </li>
                          <li>
                            <strong>Table View:</strong> Shows items in a compact, sortable table for easy comparison and bulk actions.
                          </li>
                          <li>Use the toggle to choose the view that best fits your task or preference.</li>
                        </ul>
                      </>
                    }
                  >
                    <div className="relative">
                      {view === "card" ? (
                        <button
                          onClick={() => changeView("table")}
                          className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-9 h-9 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                        >
                          <Grid2x2 className="font-semibold size-5" />
                        </button>
                      ) : (
                        <button
                          onClick={() => changeView("card")}
                          className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                        >
                          <WalletCards className="text-xl" />
                        </button>
                      )}
                    </div>
                  </HoverCardDetail>
                </nav>
              </div>
              <div className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar `}>
                {/* Hover Overflow Scroll Container */}
                <div className="relative w-full ">
                  <div className="flex space-x-2 w-full">
                    {/* Add Category */}

                    {/* "All" Category */}
                    <div
                      onClick={() => {
                        if (selectToolsTypes === "All") {
                        }
                        handleClickCategory({
                          types: "",
                        });
                      }}
                      className={` lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
                        selectToolsTypes === "" ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200" : "dark:hover:bg-slate-900"
                      } `}
                    >
                      <span className="lg:text-sm md:text-sm text-[12px]">All</span>
                    </div>
                    {/* Product Categories */}
                    <div className="space-x-2 flex">
                      {toolsloading ? (
                        <>
                          <ShimmerDepartmentRender />
                        </>
                      ) : (
                        <>
                          {types?.map((sale: any, index: any) => (
                            <button
                              key={index}
                              onClick={() => {
                                handleClickCategory({
                                  types: sale ?? "", // Ensure it's a string or fallback to ""
                                });
                              }}
                              className={` border px-4 py-1.5 rounded-lg xl:text-md text-sm font-semibold
                            ${selectToolsTypes === (sale ? sale.toString() : "") ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200" : "dark:hover:bg-slate-900"}`}
                            >
                              {sale}
                            </button>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {view === "card" ? <></> : <>{toolsloadingSearch && <SkeletonMusicLibrariesTable />}</>}
            <div className="pb-3 h-full mt-5">
              {view === "card" ? (
                <>
                  {toolsloadingSearch ? (
                    <>
                      <ShimmerStaffRender />
                    </>
                  ) : (
                    <>
                      <div className={`grid md:grid-cols-3  ${window.innerWidth < 1500 ? " lg:grid-cols-6" : "lg:grid-cols-8"}  gap-y-3 gap-x-2 mb-10 `}>
                        {tools?.map((item: any, index: number) => {
                          return (
                            <div
                              onClick={() => {
                                setIsDailogDetailTools(true);
                                setIsDetailTools(item);
                              }}
                              key={index}
                              className="relative z-1 w-full max-w-sm border rounded-lg cursor-pointer"
                            >
                              <div className="w-full relative overflow-hidden">
                                <ImageUrl className="rounded-t-md cursor-pointer object-cover h-[220px] w-full" src={item?.image_url} alt="" />
                              </div>
                              <div className="p-4">
                                <h5 className="text-md font-semibold line-clamp-1 overflow-hidden ">{item?.title}</h5>
                                <span className="text-sm text-muted-foreground line-clamp-1 overflow-hidden">{item?.type}</span>
                                <span className="text-sm line-clamp-3 overflow-hidden h-[65px]">{item?.sub_title}</span>
                                <span className="text-md font-semibold ">Learn more...</span>

                                <div onClick={(e) => e.stopPropagation()} className="flex items-center gap-2 h-[20px] mt-4">
                                  {item.ios_url && (
                                    <Link to={item?.ios_url} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
                                      <img src={appStoreLogo} className={`${window.innerWidth > 1500 ? "w-[40px] h-[40px]" : "w-[20px] h-[20px]"}`} alt="logo" />
                                    </Link>
                                  )}
                                  {item.android_url && (
                                    <Link to={item?.android_url} target="_blank" rel="noopener noreferrer">
                                      <img src={playStoreLogo} className={`${window.innerWidth > 1500 ? "w-[30px] h-[30px]" : "w-[20px] h-[20px]"}`} alt="logo" />
                                    </Link>
                                  )}
                                  {item.web_url && (
                                    <Link to={item?.web_url} target="_blank" rel="noopener noreferrer">
                                      <Globe className={` ${window.innerWidth > 1500 ? "w-[30px] h-[30px]" : "w-[20px] h-[20px]"} text-blue-500`} />
                                    </Link>
                                  )}
                                  {item.window_url && (
                                    <Link to={item?.window_url} target="_blank" rel="noopener noreferrer">
                                      <i className={`fa-brands fa-windows ${window.innerWidth > 1500 ? "text-[30px]" : "text-[20px]"} text-blue-500`} />
                                    </Link>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
                    <thead className="sticky top-0 left-0 bg-gray-200 dark:bg-[#2c3a52] w-full">
                      <tr className="border-none">
                        <th className="py-2  px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                        <th className="py-2 px-4 text-start ">Title</th>
                        <th className="py-2 px-4 text-start ">Types</th>
                        <th className="py-2 px-4 text-start">Sub title</th>
                        <th className="py-2 px-4 text-start">Learn more</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tools?.map((item: any, index: number) => (
                        <tr
                          onClick={() => {
                            setIsDailogDetailTools(true);
                            setIsDetailTools(item);
                          }}
                          key={index}
                          className={`text-center cursor-pointer ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}
                        >
                          <td className="relative w-[100px] h-[100px]">
                            <ImageUrl src={item.image_url} className="w-[100px] h-[100px] z-1 mx-auto relative" alt="" />
                          </td>
                          <td className="py-2 px-4 text-md  text-start ">
                            <p className="text-md ">{item?.title}</p>
                          </td>
                          <td className="py-2 px-4 text-md  text-start ">
                            <p className="text-md ">{item?.type}</p>
                          </td>
                          <td className={`py-1 px-4 text-md text-start  line-clamp-3 ${window.innerWidth >= 1500 ? "w-[500px]" : ""}`}>
                            <span
                              className="  overflow-hidden"
                              dangerouslySetInnerHTML={{
                                __html: item?.sub_title.replace(/\n/g, "<br />"),
                              }}
                            ></span>
                          </td>
                          <td className="py-2 px-4 text-md   ">
                            <div className="flex items-center gap-2 h-[20px]">
                              {item.ios_url && (
                                <Link to={item?.ios_url} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
                                  <img src={appStoreLogo} className={`${window.innerWidth > 1500 ? "w-[40px] h-[40px]" : "w-[20px] h-[20px]"}`} alt="logo" />
                                </Link>
                              )}
                              {item.android_url && (
                                <Link to={item?.android_url} target="_blank" rel="noopener noreferrer">
                                  <img src={playStoreLogo} className={`${window.innerWidth > 1500 ? "w-[30px] h-[30px]" : "w-[20px] h-[20px]"}`} alt="logo" />
                                </Link>
                              )}
                              {item.web_url && (
                                <Link to={item?.web_url} target="_blank" rel="noopener noreferrer">
                                  <Globe className={` ${window.innerWidth > 1500 ? "w-[30px] h-[30px]" : "w-[20px] h-[20px]"} text-blue-500`} />
                                </Link>
                              )}
                              {item.window_url && (
                                <Link to={item?.window_url} target="_blank" rel="noopener noreferrer">
                                  <i className={`fa-brands fa-windows ${window.innerWidth > 1500 ? "text-[30px]" : "text-[20px]"} text-blue-500`} />
                                </Link>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
          </div>
        </BusinessSuiteContentLayout>
      )}

      <DailogDetailTools isDetailTools={isDetailTools} isDailogDetailTools={isDailogDetailTools} setIsDailogDetailTools={setIsDailogDetailTools} />
    </>
  );
}
